import { ReactNode } from 'react';
import styles from './MenuButton.module.css';
import typeface from 'utils/typeface.module.css';
import { joinClassNames } from 'utils/arrays';

interface MenuButtonProps {
    children: ReactNode;
    href?: string;
    callback?: () => void;
}

function MenuButton({ children, href, callback }: MenuButtonProps) {
    function onClickListener() {
        if (href) {
            window.location.href = href;
        }

        if (callback) {
            callback();
        }
    }

    return (
        <button
            onClick={onClickListener}
            className={joinClassNames(styles.MenuButton, typeface.Title)}>
            <div className={styles.ChildContainer}>{children}</div>
        </button>
    );
}

export default MenuButton;
export type { MenuButtonProps };
